<div class="content-footer">
  <ul class="link-github">
    <li class="item-link-github">&copy;2022</li>
    <a *ngFor="let item of cardTeam" class="link-github-footer" href="{{ item.hrefPerson }}" target="_blank"
      ><li class="item-link-github">{{ item.namePerson }}</li></a
    >
  </ul>
  <a class="rslink-footer" href="https://rs.school/angular/" target="_blank"
    ><img src="../../../../../assets/images/rs_school_js.svg" alt="logo" style="height: 50px"
  /></a>
</div>
